import React from 'react';
import styled from 'styled-components'
import stepleft from 'images/icon/arrow_left_4e4e4e-25x48.png'
import stepright from 'images/icon/arrow_right_4e4e4e-25x48.png'

export default function GroupBottom(props) {
    return(
        <>
        {
            props.next ?
            <Btmtext 
                position={props.position}
                bg={props.bg}
                >
                <Prev onClick={()=>{props.updateNext(-1)}} display={props.prevdisplay}><Arrow><img src={stepleft}></img></Arrow>이전</Prev>
                <Text onClick={props.textClick} color={props.color}>{props.text}</Text>
                <Prev  onClick={()=>{props.updateNext(1)}} display={props.nextdisplay}>다음<Arrow2><img src={stepright}></img></Arrow2></Prev>
            </Btmtext>
            :
            <Btmtext 
                position={props.position}
                bg={props.bg}
                >
                <Prev onClick={()=>{props.updateNext(-1)}}  display={props.prevdisplay}><Arrow><img src={stepleft}></img></Arrow>이전</Prev>
                <Text onClick={props.textClick} color={props.color}>{props.text}</Text>
                <Prev onClick={()=>{}} display={props.nextdisplay}>다음<Arrow2><img src={stepright}></img></Arrow2></Prev>
            </Btmtext>
        }
         </>   
    );
}


const Btmtext = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    position: ${props=> props.position};
    bottom:0;
    left:0;
    width: 100%;
    height: calc(100vw*(56/375));
    background-color: #ffcf19;
    background-color:${props=> props.bg};
    font-size: calc(100vw*(16/375));
    line-height: calc(100vw*(56/375));
    letter-spacing: 0.25px;
    text-align: center;
    color: #4e4e4e;
    padding : 0 calc(100vw*(18/375));
`
const Text = styled.span`
    cursor: pointer;
    font-weight: 500;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color:${props=>props.color};
`
const Prev = styled.span`
    cursor: pointer;
    font-weight: 500;
    display: none;
    display: ${props=> props.display};
    align-items: center;
`
const Arrow = styled.em`
    display:block;
    width: calc(100vw*(9/375));
    height: calc(100vw*(16/375));
    margin-right : calc(100vw*(9.5/375));
`
const Arrow2 = styled(Arrow)`
    margin-left : calc(100vw*(9.5/375));
`

